<template>
    <div class="comments">
        <h2 class="page__title title title--m">Отзывы</h2>
        <div class="comments__description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget
        </div>
        <div class="comments__items">
            <div class="comments__item" v-for="(comment, i) in comments">
                <span class="comments__name">
                    {{ comment.name }} <span class="comments__city" v-if="comment.city">{{ comment.city }}</span>
                </span>
                <span class="comments__quote">“</span>
                <div class="comments__text comments__text--small">
                    <span>{{ comment.description }}</span>
                </div>
                <button class="btn comments__full" @click="openComment(comment)" v-if="comment.description.length > 210">Показать полностью...</button>
            </div>
        </div>
        <full-comment></full-comment>
    </div>
</template>

<script>
import {store} from "../../store/comments";
import {mapState, mapActions} from "vuex";
import FullComment from "./modules/FullComment";

export default {
    name: "Comments",
    components: {FullComment},
    store,
    computed: {
        ...mapState([
            'comments',
            'showComment'
        ]),
    },
    methods: {
        ...mapActions([
            'openComment',
        ]),
    },
}
</script>
